<div class="container">
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table *ngIf="!isLoading" style="width:100%">
      <tr  class="back">
        <th>
          Name
        </th>
        <!-- <th>Edit</th> -->
      </tr>
      <tr class="td" *ngFor="let card of cards">
        <td>{{card}}</td>
        <!-- <td>
          <button mat-icon-button color="primary">
            <mat-icon>edit</mat-icon>
          </button>
        </td> -->
      </tr>
    </table>
    <div class="errorMessage">
      <div *ngIf="Errors" class="error">
          <p>{{Errors}}</p>
      </div>
    </div>
    <div class="last">
    </div>
  </div>